var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    { staticClass: "px-3" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "header-sticky" },
        [
          _c(
            "v-card",
            {
              staticClass: "w-100",
              attrs: {
                "min-width": "640",
                width: "100%",
                elevation: "0",
                color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "grey lighten-3",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "start", "no-gutters": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { large: "" } },
                        [_vm._v("mdi-chart-box-outline")]
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("statistics")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "2" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.periodTypeOptions,
                              "item-text": "text",
                              "item-value": "value",
                              label: _vm.$t("kpiPeriodType"),
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.periodType,
                              callback: function ($$v) {
                                _vm.periodType = $$v
                              },
                              expression: "periodType",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "2" } },
                        [
                          _vm.periodType === "monthly"
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      value: _vm.monthLabel,
                                                      label:
                                                        _vm.$t(
                                                          "kpiPeriodMonth"
                                                        ),
                                                      dense: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      readonly: "",
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4143606036
                                  ),
                                  model: {
                                    value: _vm.monthMenu,
                                    callback: function ($$v) {
                                      _vm.monthMenu = $$v
                                    },
                                    expression: "monthMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      type: "month",
                                      locale: "de",
                                      "first-day-of-week": "1",
                                      max: _vm.monthPickerMax,
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.monthMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.monthPickerModel,
                                      callback: function ($$v) {
                                        _vm.monthPickerModel = $$v
                                      },
                                      expression: "monthPickerModel",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm.periodType === "yearly"
                            ? _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  disabled: "",
                                  value: "",
                                  label: "",
                                },
                              })
                            : _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label:
                                                      _vm.$t(
                                                        "kpiFilterDateFrom"
                                                      ),
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                  },
                                                  model: {
                                                    value: _vm.dateFromDisplay,
                                                    callback: function ($$v) {
                                                      _vm.dateFromDisplay = $$v
                                                    },
                                                    expression:
                                                      "dateFromDisplay",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.dateFromMenu,
                                    callback: function ($$v) {
                                      _vm.dateFromMenu = $$v
                                    },
                                    expression: "dateFromMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      locale: "de",
                                      "first-day-of-week": "1",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.dateFromMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.dateFrom,
                                      callback: function ($$v) {
                                        _vm.dateFrom = $$v
                                      },
                                      expression: "dateFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "2" } },
                        [
                          _vm.periodType === "monthly" ||
                          _vm.periodType === "yearly"
                            ? _c("v-select", {
                                attrs: {
                                  items: _vm.yearOptions,
                                  label: _vm.$t("kpiPeriodYear"),
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.selectedYear,
                                  callback: function ($$v) {
                                    _vm.selectedYear = $$v
                                  },
                                  expression: "selectedYear",
                                },
                              })
                            : _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label:
                                                      _vm.$t("kpiFilterDateTo"),
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                  },
                                                  model: {
                                                    value: _vm.dateToDisplay,
                                                    callback: function ($$v) {
                                                      _vm.dateToDisplay = $$v
                                                    },
                                                    expression: "dateToDisplay",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.dateToMenu,
                                    callback: function ($$v) {
                                      _vm.dateToMenu = $$v
                                    },
                                    expression: "dateToMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      locale: "de",
                                      "first-day-of-week": "1",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.dateToMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.dateTo,
                                      callback: function ($$v) {
                                        _vm.dateTo = $$v
                                      },
                                      expression: "dateTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "2" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.scopeTypeOptions,
                              "item-text": _vm.scopeItemText,
                              "item-value": "value",
                              label: _vm.$t("kpiFilterScopeLabel"),
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.scopeType,
                              callback: function ($$v) {
                                _vm.scopeType = $$v
                              },
                              expression: "scopeType",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "2" } },
                        [
                          _c("v-autocomplete", {
                            staticClass: "scope-target-autocomplete",
                            attrs: {
                              items: _vm.scopeTargetOptions,
                              "item-text": "label",
                              "item-value": "value",
                              placeholder: _vm.orgUnitPlaceholder,
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              multiple: _vm.scopeType === "employee",
                              clearable: _vm.scopeType !== "company",
                              disabled:
                                _vm.scopeType === "company" ||
                                (_vm.scopeType !== "company" &&
                                  _vm.scopeTargetOptions.length === 0),
                            },
                            model: {
                              value: _vm.scopeTarget,
                              callback: function ($$v) {
                                _vm.scopeTarget = $$v
                              },
                              expression: "scopeTarget",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "pa-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-1 d-flex",
                          attrs: { cols: "12", sm: "6", md: "2" },
                        },
                        [
                          _c("ValueKpi", {
                            attrs: {
                              "kpi-title": _vm.$t("dailySicknessRate"),
                              "kpi-value": _vm.currentSicknessRate,
                              "kpi-unit": "%",
                              decimals: 1,
                              icon: "mdi-hospital-box-outline",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }